@if (!sidebar) {
  <div>
    <button mat-button [matMenuTriggerFor]="menu" class="btn app-btn-variety">
      <span class="variety-options-title" translate>{{ varietyName ? varietyName : 'Select variety options'}}</span> <i class="fa fa-angle-down ml-1 mr-1"></i>
    </button>
    <mat-menu #menu="matMenu" class="options-vertical-menu">
      <a mat-menu-item
        class="dropdown-item options-vertical--dropdown-item variety-option"
        [ngClass]="{'selected': varietyName == 'myProducts'}"
        (click)="saveVariety('myProducts')">
        {{'my products' | translate}}
      </a>
      <a mat-menu-item
        class="dropdown-item options-vertical-menu variety-option"
        [ngClass]="{'selected': varietyName == 'allProducts'}"
        (click)="saveVariety('allProducts')">
        {{'All products' | translate}}
      </a>
    </mat-menu>
  </div>
}


@if (sidebar) {
  <div>
    <ng-container>
      <div  class="list-item">
        <div class="btn btn-light btn-sidebar btn-sidebar-1"
          (click)="saveVariety('myProducts')"
          translate>
          <span class="flag flag-icon-background flag-icon mx-2">
          </span>
          {{'my products' | translate}}
        </div>
      </div>
      <div class="list-item">
        <div class="btn btn-light btn-sidebar btn-sidebar-1"
          (click)="saveVariety('allProducts')"
          translate>
          <span class="flag flag-icon-background flag-icon mx-2"></span>
          {{'All products' | translate}}
        </div>
      </div>
    </ng-container>
  </div>
}
